import { CheckCircleOutlineOutlined, FiberManualRecord } from '@mui/icons-material';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { blue, green } from '@mui/material/colors';
import { Link } from 'react-router-dom';
import { TaskIcon, FormIcon, ProcessIcon, RegistersIcon } from '../../Global/Icons';
import StateManager from '../../Global/StateManager';
import { UserGroup } from '../../Global/Components';
import { isArray, isEmpty } from 'lodash';

const ENTRY_TYPES_TEXTS = {
  processStep: 'step',
  formEntry: 'entry',
};

export default function CreatedAction({ actionType, entryType, data }) {
  const entryTypeText = ENTRY_TYPES_TEXTS[entryType];

  return (
    <Grid container component={Paper} elevation={3} sx={{ mt: 1, p: 1, borderRadius: 1.5 }} alignItems="center">
      {actionType === 'formEntry' && (
        <>
          {data.completedAt ? (
            <CheckCircleOutlineOutlined style={{ color: green[500] }} />
          ) : (
            <FiberManualRecord style={{ color: blue[500] }} />
          )}
          <Link to={`/forms/entry/${data._id}`}>
            <Button endIcon={<FormIcon />} sx={{ textTransform: 'none', mx: 2 }}>
              {data.title} #{data.number}
            </Button>
          </Link>
          <Typography>was created from this {entryTypeText}</Typography>

          {isArray(data.assignedUsers) && !isEmpty(data.assignedUsers) && (
            <UserGroup ids={data.assignedUsers} avatarSize={32} style={{ marginLeft: 'auto' }} />
          )}
        </>
      )}
      {actionType === 'processEntry' && (
        <>
          {data.completedAt ? (
            <CheckCircleOutlineOutlined style={{ color: green[500] }} />
          ) : (
            <FiberManualRecord style={{ color: blue[500] }} />
          )}

          <Link to={`/processes/ongoing/${data._id}`}>
            <Button endIcon={<ProcessIcon />} sx={{ textTransform: 'none', mx: 2 }}>
              {data.title} #{data.number}
            </Button>
          </Link>
          <Typography>was created from this {entryTypeText}</Typography>

          {isArray(data.owners) && !isEmpty(data.owners) && (
            <UserGroup ids={data.owners} avatarSize={32} style={{ marginLeft: 'auto' }} />
          )}
        </>
      )}
      {actionType === 'task' && (
        <>
          {data.completedDate ? (
            <CheckCircleOutlineOutlined style={{ color: green[500] }} />
          ) : (
            <FiberManualRecord style={{ color: blue[500] }} />
          )}

          <Button
            onClick={() => StateManager.selectTask(data._id)}
            endIcon={<TaskIcon />}
            sx={{ textTransform: 'none', mx: 2 }}
          >
            {data.title}
          </Button>
          <Typography>was created from this {entryTypeText}</Typography>

          {isArray(data.assignedUsers) && !isEmpty(data.assignedUsers) && (
            <UserGroup ids={data.assignedUsers} avatarSize={32} style={{ marginLeft: 'auto' }} />
          )}
        </>
      )}
      {actionType === 'registerRow' && (
        <>
          <Link to={`/registers/${data.registerId}?rowId=${data._id}&highlightRow=true`}>
            <Button endIcon={<RegistersIcon />} sx={{ textTransform: 'none', mr: 2 }}>
              {data.registerTitle} #{data.index}
            </Button>
          </Link>

          <Typography>was created from this {entryTypeText}</Typography>
        </>
      )}
    </Grid>
  );
}
